import { sumBy } from 'lodash-es'
import { defineStore } from 'pinia'
import { ref } from 'vue'
import { useApp } from '~/hooks/app'
import { useConnectionStore } from '~/store/connection'

export const tpsSamples = 5

export const useClusterStore = defineStore('cluster', () => {
  const connectionStore = useConnectionStore()
  const hourlySlotTime = ref(550)
  const tpsLoading = ref(true)
  const tps = ref<number>(0)

  async function calcHourlySlotTime() {
    const { isClient } = useApp()

    try {
      if (!isClient.value) {
        return
      }
      tpsLoading.value = true
      // @ts-expect-error ...
      const { result } = await connectionStore.connection._rpcRequest('getRecentPerformanceSamples', [60])
      const samples: { numSlots: number, samplePeriodSecs: number }[] = result ?? []

      const totalSecs = sumBy(result.slice(-tpsSamples), 'samplePeriodSecs')
      const totalTransactions = sumBy(result.slice(-tpsSamples), 'numTransactions')
      tps.value = totalTransactions / totalSecs
      tpsLoading.value = false

      const timePerSlotSamples = samples
        .filter(s => s.numSlots !== 0)
        .map(s => s.samplePeriodSecs / s.numSlots)

      const samplesInHour = Math.min(timePerSlotSamples.length, 60)

      const avgSlotTime_1h = timePerSlotSamples.reduce((sum: number, cur: number) => {
        return sum + cur
      }, 0) / samplesInHour

      hourlySlotTime.value = Math.round(1000 * avgSlotTime_1h)
    } catch {
      tps.value = 0
      tpsLoading.value = false
    }
  }

  return {
    tps,
    tpsLoading,
    hourlySlotTime,
    calcHourlySlotTime,
  }
})
